import AuthException from './AuthException';

export default class InactivityException extends AuthException {}
